import { render, staticRenderFns } from "./GmzGxhtxx.vue?vue&type=template&id=47df01e2&scoped=true&"
import script from "./GmzGxhtxx.vue?vue&type=script&lang=js&"
export * from "./GmzGxhtxx.vue?vue&type=script&lang=js&"
import style0 from "./GmzGxhtxx.vue?vue&type=style&index=0&id=47df01e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47df01e2",
  null
  
)

export default component.exports